module.exports = __webpack_public_path__ + "static/media/18ECA43.154847da.jpg";